<script setup>
import SearchResultItem from "@/v2/components/Search/shared/SearchResultItem.vue";
import useScrollSkewAnimation from "@/v2/shared/useScrollSkewAnimation.js";
import useScrollDrag from "@/v2/shared/useScrollDrag.js";
import { onMounted, onBeforeUnmount, watch, ref } from "vue";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  highlightedOptionPath: {
    type: String,
    default: "",
  },
  visitedItems: {
    type: Array,
    required: true,
  },
});

defineEmits(["onSelectOption"]);

const { destroy, reload } = useScrollSkewAnimation(
  ".search-result-items",
  ".search-result-item"
);

const scrollContainer = ref(null);

useScrollDrag({
  container: scrollContainer,
});

onMounted(() => {
  reload();
});

onBeforeUnmount(() => {
  destroy();
});

watch(
  () => props.options,
  () => {
    reload();
  }
);
</script>

<template>
  <div class="search-result-items--fade" />
  <div ref="scrollContainer" class="search-result-items">
    <div class="search-result-items--inner">
      <SearchResultItem
        v-for="(option, o) in options"
        :key="`option-${o}`"
        :option="option"
        :is-visited="visitedItems.includes(`${option.path}${option.name}`)"
        :is-highlighted="highlightedOptionPath === option.path"
        @click="$emit('onSelectOption', option)"
      />
      <div class="search-result-items--scroll-spacer" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.search-result-items {
  display: flex;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  position: absolute;
  left: 0;
  top: 0;
  user-select: none;

  &::-webkit-scrollbar {
    display: none;
  }

  &--inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: var(--spacing-base-sm);
    padding: var(--spacing-outline);
  }

  &--fade {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 300px;
    background: linear-gradient(
      to bottom,
      rgba(0 0 0 / 0%) 0,
      var(--main-menu-surface) 100%
    );
    z-index: 1;
    pointer-events: none;
  }

  &--scroll-spacer {
    width: 100%;
    height: 150px;
    flex-shrink: 0;
  }
}
</style>
